import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Swiper } from 'swiper/vue';
import 'swiper/css';
import "swiper/css/pagination"
import SwiperCore, {
  Pagination
} from 'swiper'


export default /*#__PURE__*/_defineComponent({
  __name: 'dynamicSwiper',
  props: {
    pagination: { type: Boolean },
    classSwiper: null
  },
  setup(__props: any) {

const props = __props as {
  pagination: boolean
  classSwiper: string
}

SwiperCore.use([Pagination]);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Swiper), {
      spaceBetween: 30,
      pagination: props.pagination,
      class: _normalizeClass([props.classSwiper, "block md:hidden"]),
      "slides-per-view": 1
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["pagination", "class"]),
    _createVNode(_unref(Swiper), {
      spaceBetween: 30,
      pagination: props.pagination,
      class: _normalizeClass([props.classSwiper, "hidden md:block"]),
      "slides-per-view": 2
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["pagination", "class"])
  ], 64))
}
}

})